const formatDate = date => {
    const d = new Date(date);
    const months = [
        'január',
        'február',
        'március',
        'április',
        'május',
        'június',
        'július',
        'augusztus',
        'szeptember',
        'október',
        'november',
        'december'
    ];

    return `${d.getFullYear()}. ${months[d.getMonth()]} ${d.getDate()}.`;
};

export default formatDate;


// WEBPACK FOOTER //
// ./src/util/format-date.js